import React, { useRef, useEffect, useState } from 'react';
import customStyles from "../../../../assets/styles/customStyles";
import clsx from "clsx";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import zoomIn from "../../../../assets/images/icon_actions/zoom-in.png";
import zoomOut from "../../../../assets/images/icon_actions/zoom-out.png";
import pan from "../../../../assets/images/icon_actions/pan.png";
import ReactApexChart from "react-apexcharts";
import { NavLink } from "react-router-dom";
import { Image, Dropdown, Menu } from "antd";
import { currencyFormatInt, downloadImageCommon, exportChatFile, numDifferentiation } from "../../../../helpers/utilities";
import useMediaQuery from '@mui/material/useMediaQuery';
import infoMarkIcon from "../../../../assets/images/icon_actions/infoMark.svg";
import { Tooltip, IconButton } from "@mui/material";


export const Trend = (props) => {
    const { title, invoiceCounts, invoiceAmounts, months, toolTip } = props;
    const trends = useRef(null);
    const [data, setData] = useState(0);
    const classes = customStyles();
    const showText = useMediaQuery('(min-width:1300px)');

    useEffect(() => {
        if (invoiceCounts) {
            setData(invoiceCounts.reduce((a, v) => a = a + v, 0));

        }
    }, [invoiceCounts])

    const chartData = {
        chart: {
            type: "line",
            redrawOnWindowResize: true,
            toolbar: {
                show: showText ? true : false,
                tools: {
                    download: `<img src="${hamburgerMenu}" width="20">`,
                    selection: false,
                    zoom: false,
                    zoomin: `<img src="${zoomIn}" width="20">`,
                    zoomout: `<img src="${zoomOut}" width="20">`,
                    pan: `<img src="${pan}" width="20">`,
                    reset: false | '<img src="/static/icons/reset.png" width="20">',
                    customIcons: [],
                },
                offsetX: 25
            }
        },
        grid: {
            show: true,
            borderColor: '#d9d9d9',
            yaxis: {
                lines: {
                    show: true,  //or just here to disable only y axis
                    opacity: 0.5
                }
            },
            row: {
                colors: undefined,
                opacity: 0.5
            },
            column: {
                colors: undefined,
                opacity: 0.5
            },
        },
        fill: {
            opacity: 1
        },
        states: {
            hover: {
                filter: {
                    type: 'darken',
                    value: 0.35,
                }
            },
        },
        tooltip: {
            enabled: true,
            style: {
                fontSize: '10px',
                fontFamily: 'Roboto',
                fontWeight: 500,
            },
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                return '<div class="arrow_box">' +
                    '<div class="invoices"><div>Invoice Count</div><div>' + series[1][dataPointIndex] + '</div></div>' +
                    '<div class="invoice_amount"><div>Invoice Amounts</div><div>₹ ' + currencyFormatInt(series[0][dataPointIndex]) + '</div></div>' +
                    '</div>';
            }
        },
        legend: {
            show: showText ? true : false,
            position: 'top',
            horizontalAlign: 'right',
            offsetY: -5,
            markers: {
                radius: 0,
            },
        },
        stroke: {
            show: true,
            width: [2, 4],
            colors: ['rgba(0, 0, 0, 0.5)', 'transparent']
        },
        xaxis: {
            type: 'category',
            axisTicks: {
                show: false,
            },
            labels: {
                rotateAlways: false,
                style: {
                    fontFamily: "Roboto",
                    fontSize: showText ? 11 : 9,
                }
            },
            categories: months,
            title: {
                text: '',
            },
            crosshairs: {
                show: true,
                stroke: {
                    color: '#d20b0b',
                    width: 1,
                    dashArray: 4,
                },
            },
            tooltip: {
                enabled: false,
            },
        },
        markers: {
            size: 4,
            colors: ['#1c314c', '#ffa539'],
            strokeWidth: 0,
            fillOpacity: 1,
            shape: "circle",
            hover: {
                colors: ['#d20b0b'],
                size: 4,
                fillOpacity: 1,
            }
        },
        yaxis: [{
            labels: {
                style: {
                    fontFamily: "Roboto",
                    fontSize: showText ? 11 : 9,
                },
                formatter: function (val, index) {
                    return numDifferentiation(val);
                }
            }
        }, {
            opposite: true,
            min: 0,
            max: data,
            tickAmount: data > 3 ? 4 : data,
            labels: {
                style: {
                    fontFamily: "Roboto",
                    fontSize: showText ? 11 : 9,
                },
                formatter: function (val, index) {
                    return parseFloat(val).toFixed(0);
                }
            },
        }],
        title: {
            text: `${title}`,
            style: {
                color: "#14a4c2",
                fontSize: '14px',
                fontFamily: 'Roboto',
                fontWeight: 500,
            },
            offsetX: showText ? -30 : 0
        },
        series: [
            {
                color: "#1c314c",
                name: 'Invoice Amounts',
                type: 'column',
                data: invoiceAmounts
            }, {
                color: "#14a4c2",
                name: 'Invoice Counts',
                type: 'line',
                data: invoiceCounts
            }
        ]
    };

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(trends.current, title, type);
        }
    }
    const exportFile = () => {
        let newHead = [months, invoiceAmounts, invoiceCounts];
        exportChatFile(`${title}`, newHead);
    }


    return (
        <div ref={trends} style={{ height: "100%" }}>
            <div className={clsx(classes.chartDiv, { [classes.salesTrendsChart]: title === 'Sales Trend' }, { [classes.mobileDevice]: !showText })}>
                <span className={clsx(classes.hamburgerMenu, classes.chartDivDownload, 'customhamburgerIcon')}>
                    <Dropdown
                        placement="bottomLeft"
                        trigger={['click']}
                        overlay={
                            <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                            </Menu>
                        }>
                        <Image src={hamburgerMenu} preview={false} />
                    </Dropdown>
                </span>
                <div className={classes.invoiceAmount}>Invoice Amounts</div>
                <div className={classes.invoiceCounts}>Invoice Counts</div>
                <div className={classes.invoiceMonths}>Months</div>
                <Tooltip
                    classes={{ popper: classes.customToolTip }}
                    title={toolTip}
                    arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom, classes.tooltipTrends)}>
                    <IconButton>
                        <Image src={infoMarkIcon} preview={false} />
                    </IconButton>
                </Tooltip>
                <ReactApexChart type="line" options={chartData} height={showText ? 'auto' : 185} series={chartData.series} />
            </div>
        </div>
    );
}


